import { request } from '../request';

export const tokenUsageApi = {
  getTokenUsage: ({ start_date, end_date }) => {
    const params = new URLSearchParams({ start_date, end_date });
    return request(`/token-usage?${params.toString()}`);
  }
};
